// extracted by mini-css-extract-plugin
export default {"title":"Styles_title__Jrcku","button":"Styles_button__jrhz5"};